import React from 'react';
import { Paperclip, X, Image as ImageIcon, ImagePlus } from 'lucide-react';

export const MediaPreview = ({ selectedMedia, onClear }) => {
  if (!selectedMedia) return null;
  return (
    <div style={{ padding: '8px 24px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: '8px' }}>
      <div style={{ padding: '6px 12px', background: '#e2e8f0', borderRadius: '4px', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '6px' }}>
        <ImageIcon size={14} />
        <span style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {selectedMedia.name}
        </span>
        <button 
          type="button"
          onClick={onClear}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', color: '#64748b' }}
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

export const MediaSendButton = ({ onSelect }) => {
  return (
    <label
      style={{
        background: '#e2e8f0',
        border: 'none',
        cursor: 'pointer',
        color: '#64748b',
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'background 0.2s',
        flexShrink: 0
      }}
      title="Attach Media"
    >
      <input 
        type="file" 
        style={{ display: 'none' }} 
        onChange={(e) => {
          if (e.target.files && e.target.files[0]) {
            onSelect(e.target.files[0]);
            // Reset input so the same file can be selected again if cleared
            e.target.value = null; 
          }
        }} 
      />
      <Paperclip size={18} />
    </label>
  );
};

export const LibrarySendButton = ({ onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        background: '#e2e8f0',
        border: 'none',
        cursor: 'pointer',
        color: '#64748b',
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'background 0.2s',
        flexShrink: 0
      }}
      title="Choose from Media Library"
      onMouseEnter={e => e.currentTarget.style.background = '#cbd5e1'}
      onMouseLeave={e => e.currentTarget.style.background = '#e2e8f0'}
    >
      <ImagePlus size={18} />
    </button>
  );
};
